import { render, staticRenderFns } from "./DesignTokenView.vue?vue&type=template&id=f6981160&"
import script from "./DesignTokenView.vue?vue&type=script&lang=js&"
export * from "./DesignTokenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports